<template>
  <div class="mb-5 pb-5">
    <div class="">
      <!--          <div class="d-flex  mt-3 mb-2" v-if="false && step !== 0">-->
      <!--            <span class="ml-auto mr-3" v-if="survey_type === 1">Postęp wypełniania formularza {{Math.round(parseFloat((step-1) * 100/5))}}%</span>-->
      <!--            <span class="ml-auto mr-3" v-else>Postęp wypełniania formularza {{Math.round(parseFloat((step-1) * 100/3))}}%</span>-->
      <!--          </div>-->
      <!--          <div class="progress ml-3 mr-3" style="height: 15px;" v-if="false && step !== 0">-->
      <!--            <div class="progress-bar" v-if="survey_type === 1" role="progressbar" :style="'width: ' + (step-1) * 100/5 + '%;'" :aria-valuenow="(step-1) * 100/5" aria-valuemin="0" aria-valuemax="100"></div>-->
      <!--            <div class="progress-bar" v-else role="progressbar" :style="'width: ' + (step-1) * 100/3 + '%;'" :aria-valuenow="(step-1) * 100/3" aria-valuemin="0" aria-valuemax="100"></div>-->
      <!--          </div>-->
      <!--          <div class="steps" v-if="step !== 0">-->
      <!--            <ul id="progressbar">-->
      <!--              <li :class="getClasses(1)" @click="changeStep(1)">Umowa partnerska 1</li>-->
      <!--            </ul>-->
      <!--          </div>-->
      <div
        class="flex items-center justify-between bg-white py-4 px-5 m-3 mb-10 h-[68px]"
      >
        <div class="pointerable" @click="reset">
          <svg
            width="80"
            height="18"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80.4 18.41"
          >
            <path
              class="logo-mark"
              fill="#450d35"
              d="M56.33 13.52L45.58.32h-2.56V18.1h2.76V4.93l10.74 13.19h2.56V.34h-2.75zM80.35 8.51h-8.03v2.33h5.2a5.4 5.4 0 01-5.8 4.97 6.58 6.58 0 01.04-13.15 6.4 6.4 0 014.89 2.17l1.98-1.92a9.24 9.24 0 10-6.9 15.46c5.02 0 8.65-3.84 8.67-9.06a6.28 6.28 0 00-.05-.8zM29.32.31L21.74 18.1h2.85l1.24-2.96h10.2l1.25 2.96h2.95L32.65.31zm-2.45 12.31l4.06-9.71L35 12.62z"
            ></path>
            <g class="logo-brand">
              <path
                d="M18.41 9.2A9.2 9.2 0 119.21 0a9.2 9.2 0 019.2 9.2"
                fill="#e94153"
              ></path>
              <path
                d="M7.48 15.12a.32.32 0 01-.28-.47l1.2-2.26h1.34a.32.32 0 110 .63h-.96l-1.02 1.93a.32.32 0 01-.28.17zm5.32 0h-.01a.32.32 0 01-.3-.33l.05-1.2-1.07-1.08V10.8L8.82 8.4V5.77l1.83-2.09 2.66.58 2.97 5.52-4.02-.8a.32.32 0 11.13-.63l2.68.54-2.19-4.07-2-.43L9.46 6v2.13l2.64 2.39v1.73l1.1 1.09-.08 1.48a.32.32 0 01-.32.3zm-1.81 0H9.87a.32.32 0 110-.64h.73l.45-.87a.32.32 0 11.56.3zm-4.8 0h-.91a.32.32 0 110-.64h.5l1.15-2.62-1.16-1a.32.32 0 11.42-.49l1.51 1.32zm-.92-2.76a.32.32 0 01-.21-.08l-1.5-1.41 1.26-1.56a.32.32 0 11.5.4l-.9 1.1 1.08 1a.32.32 0 01-.22.55zm1.99-4.41a.32.32 0 01-.32-.32v-2.6l-.5-.8.2-.3H5.02L3.74 5.21l.24.41 1.13-.11a.32.32 0 01.06.63l-1.53.16-.7-1.2 1.82-1.8h3.1l-.67.95.37.6v2.77a.32.32 0 01-.3.32z"
                fill="#fff"
              ></path>
            </g>
          </svg>
        </div>
        <div v-if="step > 0" class="w-1/2">
          <div class="flex justify-between items-center mb-2 text-violet">
            <span class="font-bold text-xs">Postęp wypełniania formularza</span>
            <span class="font-bold text-sm">{{ progress }}%</span>
          </div>
          <div class="flex h-1.5 overflow-hidden rounded-lg bg-pink-light">
            <div
              class="flex flex-col bg-pink-dark justify-center overflow-hidden transition duration-300 ease-in-out"
              role="progressbar"
              :style="'width: ' + progress + '%'"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
        <div class="font-bold text-violet">
          <span class="uppercase">Krok</span> {{ steps.indexOf(step) + 1 }}/{{
            steps.length
          }}
        </div>
      </div>
      <div class="container">
        <welcome
          :data="data"
          :shortcut="shortcut"
          v-if="step === 0"
          @nextStep="nextStep"
        ></welcome>
        <rules
          :data="data"
          :step="step"
          :shortcut="shortcut"
          v-if="step === 1"
          @forward="nextStep"
        ></rules>
        <partner-form
          :data="data"
          :step="step"
          :shortcut="shortcut"
          v-if="data && data.new_partner && step >= 2 && step < 10"
          @forward="nextStep"
          @back="prevStep"
        ></partner-form>
        <employee-form
          :data="data"
          :step="step"
          :shortcut="shortcut"
          v-if="data && step >= 10 && step < 20"
          @forward="nextStep"
          @back="prevStep"
        ></employee-form>
        <agent-form
          :data="data"
          :step="step"
          :shortcut="shortcut"
          v-if="data && step >= 20 && step < 30"
          @forward="nextStep"
          @back="prevStep"
        ></agent-form>
        <data-summary
          :data="data"
          :step="step"
          :shortcut="shortcut"
          v-if="data && step === 30"
          @forward="nextStep"
          @back="prevStep"
        ></data-summary>
        <documents
          :data="data"
          :step="step"
          :shortcut="shortcut"
          v-if="data && step === 40"
          @forward="nextStep"
          @back="prevStep"
        ></documents>
        <upload
          :data="data"
          :step="step"
          :shortcut="shortcut"
          v-if="data && step === 41"
          @forward="nextStep"
          @back="prevStep"
        ></upload>
      </div>
    </div>
  </div>
</template>

<script>
import welcome from "@/components/partials/forms/recrutation/welcome";
import rules from "@/components/partials/forms/recrutation/rules";
import partnerForm from "@/components/partials/forms/recrutation/partnerForm";
import employeeForm from "@/components/partials/forms/recrutation/employeeForm";
import agentForm from "@/components/partials/forms/recrutation/agentForm";
import dataSummary from "@/components/partials/forms/recrutation/dataSummary";
import documents from "@/components/partials/forms/recrutation/documents";
import upload from "@/components/partials/forms/recrutation/upload";
import api from "@/services/api";
// import moment from "moment"
export default {
  data() {
    return {
      step: 0,
      data: {},
      shortcut: null,
      steps: [],
      progress: 0,
    };
  },
  components: {
    welcome,
    rules,
    "partner-form": partnerForm,
    "employee-form": employeeForm,
    "agent-form": agentForm,
    "data-summary": dataSummary,
    documents,
    upload,
  },
  name: "RecrutationMainForm",
  mounted() {
    let self = this;
    if (typeof this.$route.params.shortcut !== "undefined") {
      this.shortcut = this.$route.params.shortcut;
    } else if (typeof this.$route.query.shortcut !== "undefined") {
      this.shortcut = this.$route.query.shortcut;
    }

    self.getData();
  },
  methods: {
    setProgress() {
      this.progress = Math.round(
        (this.steps.indexOf(this.step) / (this.steps.length - 1)) * 100
      );
      this.$forceUpdate();
    },
    parseData(d) {
      let data = d;
      if (typeof data.data === "undefined" || !data.data) {
        data.data = {
          accounts: [{}, {}, {}, {}],
          board: [{}],
          reps: [{}],
          employments: [{}],
          agent: {
            board: [{}],
            reps: [{}],
          },
          account: {},
          id: {},
          disability: {},
          pension: {},
        };
      }
      if (typeof data.data.pension === "undefined") {
        data.data.pension = {};
      }
      if (typeof data.data.disability === "undefined") {
        data.data.disability = {};
      }
      if (typeof data.data.id === "undefined") {
        data.data.id = {};
      }
      if (typeof data.data.agent === "undefined") {
        data.data.agent = {};
      }
      if (typeof data.data.account === "undefined") {
        data.data.account = {};
      }
      if (typeof data.partner === "undefined") {
        data.partner = {
          data: {},
          address: {
            business: {},
          },
        };
      }
      if (
        typeof data.partner.address === "undefined" ||
        typeof data.partner.address.business === "undefined"
      ) {
        data.partner.address = {
          business: {},
        };
      }
      if (typeof data.partner.data === "undefined" || !data.partner.data) {
        data.partner.data = {};
      }
      if (typeof data.data.accounts === "undefined") {
        data.data.accounts = [{}, {}, {}, {}];
      }
      if (typeof data.data.board === "undefined") {
        data.data.board = [
          {
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            email: data.email,
            is_employed: data.roles.is_employed,
            is_owner: data.roles.is_owner,
          },
        ];
      }
      if (typeof data.data.agent.board === "undefined") {
        data.data.agent.board = [
          {
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            email: data.email,
            is_employed: data.roles.is_employed,
            is_owner: data.roles.is_owner,
          },
        ];
      }
      if (typeof data.data.reps === "undefined") {
        data.data.reps = [
          {
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            email: data.email,
            is_employed: data.roles.is_employed,
            is_owner: data.roles.is_owner,
          },
        ];
      }
      if (typeof data.data.agent.reps === "undefined") {
        data.data.agent.reps = [
          {
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            email: data.email,
            is_employed: data.roles.is_employed,
            is_owner: data.roles.is_owner,
          },
        ];
      }
      if (typeof data.data.employments === "undefined") {
        data.data.employments = [{}];
      }
      if (typeof data.recruits === "undefined") {
        data.recruits = [{}];
        // if (data.roles.is_employed > 0 || data.roles.is_owner > 1) {
        //   data.recruits = [{
        //       first_name: data.first_name,
        //       last_name: data.last_name,
        //       phone: data.phone,
        //       email: data.email,
        //       is_employed: data.roles.is_employed,
        //       is_owner: data.roles.is_owner
        //     }]
        // } else {
        //   data.recruits = [{}]
        // }
      } else {
        for (let i = 0; i < data.recruits.length; i++) {
          if (typeof data.recruits[i].companies === "undefined") {
            data.recruits[i].companies = {};
          } else {
            let ob = {};
            for (let j = 0; j < data.recruits[i].companies.length; j++) {
              ob[data.recruits[i].companies[j]] = data.recruits[i].companies[j];
            }
            data.recruits[i].companies = ob;
          }
          if (typeof data.recruits[i].groups === "undefined") {
            data.recruits[i].groups = {};
          } else {
            let ob = {};
            for (let j = 0; j < data.recruits[i].groups.length; j++) {
              ob[data.recruits[i].groups[j]] = data.recruits[i].groups[j];
            }
            data.recruits[i].groups = ob;
          }
          if (typeof data.recruits[i].data === "undefined") {
            data.recruits[i].data = {};
          }
        }
      }
      if (typeof data.address === "undefined") {
        data.address = {
          mailing: {},
          agent: {},
          office: {},
          home: {},
        };
      }
      if (typeof data.address.mailing === "undefined") {
        data.address.mailing = {};
      }
      if (typeof data.address.office === "undefined") {
        data.address.office = {};
      }
      if (typeof data.address.home === "undefined") {
        data.address.home = {};
      }
      if (typeof data.address.agent === "undefined") {
        data.address.agent = {};
      }
      return data;
    },
    getData() {
      let self = this;
      api.get(
        "/hr/recruits/" + self.shortcut,
        null,
        function (data) {
          try {
            self.data = self.parseData(data);
            self.setSteps();
          } catch (e) {
            console.log(e);
          }
        },
        function () {
          console.log("error");
        }
      );
    },
    getClasses(step) {
      let classes = "";

      if (this.step === step) {
        classes += "active";
      } else if (this.client_step < step - 1) {
        classes += "disabled";
      }

      return classes;
    },
    changeStep(step) {
      if (step < this.step || step - 1 <= this.client_step) {
        this.step = step;
      }
    },
    prevStep() {
      let i = this.steps.indexOf(this.step);
      i--;
      if (i < 0) {
        i = 0;
      }
      this.step = this.steps[i];
      this.setProgress();
    },
    nextStep(data) {
      if (typeof data !== "undefined") {
        this.data = this.parseData(data);
      }
      let i = this.steps.indexOf(this.step);
      i++;
      this.step =
        typeof this.steps[i] !== "undefined"
          ? this.steps[i]
          : this.steps[this.steps.length - 1];
      this.setProgress();
    },
    setSteps() {
      this.steps.push(0);
      this.steps.push(1);
      if (this.data.new_partner && this.data.new_partner === 1) {
        this.steps.push(2);
        if (parseInt(this.data?.data?.is_company) === 1) {
          this.steps.push(3);
        }
        this.steps.push(4);
        this.steps.push(8);
      }
      if (
        this.data.roles &&
        this.data.roles.is_agent &&
        parseInt(this.data.roles.is_agent) > 0
      ) {
        this.steps.push(20);
        if (
          this.data?.data?.agent.company_type &&
          parseInt(this.data.data.agent.company_type) > 0
        )
          this.steps.push(21);
        this.steps.push(22);
      }
      if (
        this.data.roles &&
        this.data.roles.is_employed &&
        parseInt(this.data.roles.is_employed) > 0
      ) {
        this.steps.push(10);
        // this.steps.push(11)
        this.steps.push(12);
        this.steps.push(13);
        this.steps.push(14);
        this.steps.push(15);
        this.steps.push(16);
        // this.steps.push(17)
      }

      this.steps.push(40);
      this.steps.push(41);

      for (let i = 1; i < this.steps.length; i++) {
        if (
          typeof this.data.data.step === "undefined" ||
          !this.data.data.step
        ) {
          break;
        }
        if (typeof this.data.data.step[this.steps[i]] === "undefined") {
          this.step = this.steps[i];
          break;
        }
      }

      this.setProgress();
      this.$forceUpdate();
      return;
    },
    reset() {
      window.location.href = "/";
    },
  },
};
</script>
